import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ClienteReceitaService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Cliente receitas por id
     * @param id ID da Cliente receitas
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "receitas-clientes/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente receitas
     * @param id ID da Cliente receitas
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "receitas-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente receitas
     * @param id ID da Cliente receitas
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "receitas-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Cliente receitas
     * @param id ID da Cliente receitas
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "receitas-clientes/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Cliente receitas
     * @param params Json Cliente receitas
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "receitas-clientes", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Cliente receitas
     * @param params Json Cliente receitas
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "receitas-clientes/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
